import { useMemo } from 'react';
import { DdbEngagementType } from '@/lib/graphql/types-and-hooks';
import { useEngagementsBase } from './use-engagements-base';

// Dummy data for preview mode
const dummyMeetings = [
  {
    id: '1',
    title: 'Quarterly Business Review',
    date: 'Feb 27, 2026',
    attendees: ['Sarah Chen', 'Doug'],
    companies: ['TechVentures Inc'],
  },
  {
    id: '2',
    title: 'Product Roadmap Sync',
    date: 'Feb 18, 2026',
    attendees: ['Sarah Chen', 'Alex Kim', 'Doug'],
    companies: ['TechVentures Inc'],
  },
];

const dummyEmails = [
  {
    id: '1',
    title: 'Re: Platform Migration Timeline',
    from: 'Sarah Chen',
    date: 'Feb 28, 2026',
    preview: 'Thanks for the update on the migration...',
  },
  {
    id: '2',
    title: 'Proposal Draft v2',
    from: 'Doug',
    date: 'Feb 25, 2026',
    preview: 'Attached is the updated proposal...',
  },
];

interface UseAccountEngagementsOptions {
  accountId: string;
  type?: DdbEngagementType;
  pageSize?: number;
  skip?: boolean;
}

/**
 * Hook for fetching engagements (meetings/emails) associated with a company/account
 * Supports pagination and Lovable Preview mode
 */
export const useAccountEngagements = ({
  accountId,
  type,
  pageSize = 20,
  skip = false,
}: UseAccountEngagementsOptions) => {
  const entityFilter = useMemo(() => ({ accountId }), [accountId]);

  return useEngagementsBase({
    entityFilter,
    entityId: accountId,
    type,
    pageSize,
    skip,
    dummyMeetings,
    dummyEmails,
  });
};
